import { render, staticRenderFns } from "./edit-vacancies.vue?vue&type=template&id=05796e13&lang=html&"
import script from "./edit-vacancies.vue?vue&type=script&lang=js&"
export * from "./edit-vacancies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports